import {ChartData} from "../chart-data";
import {BGChartType} from "../b-g-chart-type";


export class AddChartModel {
    constructor(public itemId: number, public GUID: string, public sharedGuid: string, public type: BGChartType){
        this.data = null;
        this.startDate = '';
        this.endDate = '';
    }
    public data: ChartData;
    public startDate: string;
    public endDate: string;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/add-chart-model.ts